import {DataPoint, MonitoringServiceType, PerformanceDataType, Service, ServiceDefinition} from "@/lib/types/checks.ts";
import {CheckResponseExpirationTime} from "@/pages/dashboard/display/components/checkCard/CheckResponseExpirationTime.tsx";
import {CheckResponsePagespeed} from "@/pages/dashboard/display/components/checkCard/CheckResponsePagespeed.tsx";
import {CheckResponseRumTime} from "@/pages/dashboard/display/components/checkCard/CheckResponseRumTime.tsx";
import {CheckResponseTimeValue} from "@/pages/dashboard/display/components/checkCard/CheckResponseTimeValue.tsx";

export const CheckResponseTime = ({
  service,
  responseTimeData,
  serviceDefinition,
}: {
  service: Service;
  serviceDefinition: ServiceDefinition;
  responseTimeData: DataPoint[];
}) => {
  if (
    [PerformanceDataType.RESPONSE_TIME, PerformanceDataType.JITTER_DELTA, PerformanceDataType.CUSTOM].includes(
      serviceDefinition.performance_data_type
    )
  ) {
    if (!responseTimeData) {
      return null;
    } else if (service.cached_response_time >= 0) {
      return <CheckResponseTimeValue serviceDefinition={serviceDefinition} service={service} />;
    }
  } else if (serviceDefinition.performance_data_type === PerformanceDataType.RUM_LOAD_TIME && responseTimeData) {
    return <CheckResponseRumTime serviceDefinition={serviceDefinition} responseTimeData={responseTimeData} />;
  } else if (
    serviceDefinition.performance_data_type === PerformanceDataType.DAYS_TO_EXPIRY &&
    service.cached_response_time >= 1.0
  ) {
    return <CheckResponseExpirationTime service={service} serviceDefinition={serviceDefinition} />;
  } else if (service.monitoring_service_type === MonitoringServiceType.PAGESPEED && service.cached_uptime_grade) {
    return <CheckResponsePagespeed service={service} />;
  }
};
